<template>
  <el-dialog
  title="请选择你所在的高考省份"
  :visible.sync="dialogVisible"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :show-close="false"
  :center="true"
  width="60%">
  <div class="head" v-loading="loading">
      <div class="heads" v-for="(item,i) in cityArr" :class="[province==item?'select':'']" :key="i" @click="cityCilci(item)">
         {{item}}
      </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
</template>

<script>
  import { getProvince } from "@/api/gw/index.js"
  export default {
     data(){
      return{
        dialogVisible:false,
        loading:false,
        cityArr:[],
        province:"",//选择省份
      }
     },
     mounted() {

     },
     methods: {
      show(){
        this.$nextTick(()=>{
          this.dialogVisible = true
          this.province = this.$cookies.get("province") || ""
          this.getProvince();
        })
      },
        async getProvince(){
          this.loading = true
          let res = await getProvince({});
          this.loading = false
          console.log("所有省份",res);
          this.cityArr = res.data
        },
        //选择省份
        cityCilci(item){
           this.province = item
           this.$emit("provinceSu",item);
           this.$cookies.set("province",item);
        },
     }
  }
</script>

<style lang="scss" scoped>
.head{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .heads{
    cursor: pointer;
    width: 110px;
height: 38px;
background: #fff;
border: 1px solid #DBDEE3;
border-radius: 5px;
display: flex;
align-items: center;
justify-content: center;
font-size: 18px;
margin-right: 20px;
margin-bottom: 20px;
  }
  .heads:hover,.select{
    color: #2AA38B!important;
    border: 1px solid #2AA38B!important;
  }
}
::v-deep .el-dialog__title{
  font-size: 22px;
  font-weight: bold;
}
::v-deep .el-button--primary{
  background: #2AA38B;
  width: 200px;
  border: 1px solid #2AA38B;
  height: 40px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/selectCity.vue